import React, {
  useMemo,
} from "react";

import {
  TOURNAMENT_GALLERY_CATEGORIES,
} from "../data/tournamentGalleryData";

import {
  cx,
} from "../utils/tournamentProductUtils";

export default function TournamentGalleryFilters({
  activeCategory,
  slides = [],
  onChange,
}) {
  const categoryCounts =
    useMemo(() => {
      return slides.reduce(
        (accumulator, slide) => {
          accumulator.all =
            (accumulator.all ||
              0) + 1;

          accumulator[
            slide.category
          ] =
            (accumulator[
              slide.category
            ] || 0) + 1;

          return accumulator;
        },
        {},
      );
    }, [slides]);

  return (
    <div className="flex gap-2 overflow-x-auto pb-2">
      {TOURNAMENT_GALLERY_CATEGORIES.map(
        (category) => {
          const Icon =
            category.icon;

          const active =
            activeCategory ===
            category.key;

          const count =
            categoryCounts[
              category.key
            ] || 0;

          return (
            <button
              key={category.key}
              type="button"
              onClick={() =>
                onChange(
                  category.key,
                )
              }
              className={cx(
                "inline-flex min-h-11 shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm font-bold transition",
                active
                  ? "border-orange-500 bg-orange-500 text-white shadow-lg shadow-orange-500/20"
                  : "border-slate-200 bg-white text-slate-600 hover:border-orange-200 hover:bg-orange-50 hover:text-orange-600 dark:border-white/10 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-orange-400/30 dark:hover:bg-orange-500/10 dark:hover:text-orange-300",
              )}
            >
              <Icon className="h-3.5 w-3.5" />

              <span>
                {category.shortLabel}
              </span>

              <span
                className={cx(
                  "rounded-full px-2 py-0.5 text-[11px]",
                  active
                    ? "bg-white/20 text-white"
                    : "bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-300",
                )}
              >
                {count}
              </span>
            </button>
          );
        },
      )}
    </div>
  );
}